class AnimatedSearchText extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.cycle()
  }

  async typeText (sentence) {
    const text = sentence.split('')

    for (let i = 0; i < text.length; i++) {
      this.els.text.element.textContent += text[i]

      await this.delay(this.typeSpeed)
    }
  }

  async deleteText () {
    const text = this.els.text.element.textContent.split('')

    for (let i = text.length; i >= 0; i--) {
      this.els.text.element.textContent =
        this.els.text.element.textContent.slice(0, i)
      await this.delay(this.deleteSpeed)
    }
  }

  async cycle () {
    for (let i = 0; i < this.data.length; i++) {
      this.els.text.element.textContent = ''
      await this.typeText(this.data[i])
      await this.delay(this.deleteDelay)
      await this.deleteText()
      await this.delay(this.nextWordDelay)
    }

    this.cycle()
  }

  delay (ms) {
    const waitTimer = new Promise((resolve) => setTimeout(resolve, ms))

    return waitTimer
  }

  get data () {
    return JSON.parse(this.els.data.element.textContent)
  }

  get typeSpeed () {
    return this.dataset.typeSpeed
  }

  get deleteSpeed () {
    return this.dataset.deleteSpeed
  }

  get deleteDelay () {
    return this.dataset.deleteDelay
  }

  get nextWordDelay () {
    return this.dataset.nextWordDelay
  }
}

if (!customElements.get('animated-search-text')) {
  customElements.define('animated-search-text', AnimatedSearchText)
}
